// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"0":"12a8f759","488":"bac09428"}[chunkId] + ".css";
};